import { Skeleton } from "@/components/ui/Skeleton";

export const ChatLoadingState = () => {
  return (
    <div className="h-full overflow-y-auto px-4 py-2">
      <div className="flex flex-col gap-4" data-testid="chat-skeleton">
        {Array.from({ length: 3 }).map((_, dateIndex) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
          <div key={dateIndex} className="mb-6">
            {/* Date separator skeleton */}
            <div className="flex justify-center my-4">
              <Skeleton className="h-4 w-32" />
            </div>

            {/* Message groups skeleton */}
            {Array.from({ length: 2 }).map((_, groupIndex) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
              <div key={groupIndex} className="mb-4">
                {/* Sender header skeleton */}
                <div className="flex items-center mb-2">
                  <Skeleton className="h-6 w-6 rounded-full mr-2" />
                  <Skeleton className="h-4 w-24" />
                </div>

                {/* Message bubbles skeleton */}
                <div className="flex flex-col gap-2">
                  {Array.from({ length: 2 }).map((_, messageIndex) => (
                    <Skeleton
                      // biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
                      key={messageIndex}
                      className="w-3/4 h-12 rounded-lg ml-8"
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
